import { RepositoryFactory } from "@/Apicall/RepositoryFactory";
const category = RepositoryFactory.get("category");
export default {
  createCategory({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await category.createCategory(payload);

        commit("CREATE_CATEGORY", data.data);

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getAllCategory({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await category.getAllCategory(payload);

        commit("GET_CATEGORY_DATA", data.data);

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getAllCategoryList({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await category.getAllCategoryList(payload);

        commit("GET_CATEGORY_DATA_LIST", data.data);

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  UpdateCategory({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await category.UpdateCategory(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
